export default {
    url: '',
    template: `
        <div class="col00">
            <h1>{{ 'reports.Reports' | translate }}</h1>
        </div>
    `,
    controller (PrivilegeService) {
        this.PrivilegeService = PrivilegeService;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/dashboard/index.js